/* eslint-disable */
/* tslint:disable */
/* auto-generated vue proxies */
import { defineContainer } from './vue-component-lib/utils';

import type { JSX } from '@ovhcloud/ods-stencil/components/icon/custom-elements';

import { defineCustomElement as defineOsdsIcon } from '@ovhcloud/ods-stencil/components/icon/custom-elements/osds-icon.js';


export const OsdsIcon = /*@__PURE__*/ defineContainer<JSX.OsdsIcon>('osds-icon', defineOsdsIcon, [
  'ariaName',
  'color',
  'contrasted',
  'hoverable',
  'name',
  'size'
]);

